export const ANSWER_MAX_LENGTH = 144;
export const CUSTOM_QUESTION_TRANSLATE_KEY =
  'descriptions.event-landing.registration-modal.custom-question-section';
